// removed by extract-text-webpack-plugin
module.exports = {"menuLink":"globalHeader-module_menuLink_1R3td","menuItem":"globalHeader-module_menuItem_2_pDb","-border-radius":"globalHeader-module_-border-radius_2SjoZ","-background-light":"globalHeader-module_-background-light_12_Qa","header":"globalHeader-module_header_2AfKy","wrapper":"globalHeader-module_wrapper_2thXt","gridWide":"globalHeader-module_gridWide_j89a1","logo":"globalHeader-module_logo_E_xUB","menu":"globalHeader-module_menu_5RGB9","menuList":"globalHeader-module_menuList_1Fs39","menuText":"globalHeader-module_menuText_3y26N"};


//////////////////
// WEBPACK FOOTER
// ./client/components/siteHeader/globalHeader.module.css
// module id = 398
// module chunks = 1 2